// 选址大脑-店铺数据管理
export default {
  meta: {
    title: '店铺数据管理',
    url: '/brain/storedata', // 埋点用，记录所属模块
    // eventId: '6c57f0e8-bfac-44fc-b02f-b980c3184174'
  },
};
